import request from "../../utils/request";
import {
    CalculateEndOfServiceInput,
    EndOfServiceDetailsInput,
    EndOfServiceDetailsView,
    EndOfServiceTypeInput,
    EndOfServiceTypeView,
    FinalSettelmentInput,
    FinalSettelmentView,
    MonthlyPayrollView,
    MonthlyPayrollInput,
    PayrollPreflightInput,
    PayrollPreflightView,
    UserBenefitView,
    UserEndOfServiceView
} from "../../models/payroll";
import { Bank, Result, User } from "../../models/general";
import { AxiosResponse } from "axios";

export async function GetUsersMonthlyPayslips(input : MonthlyPayrollInput) {
    const response = await request.post<Result<MonthlyPayrollView[]>>("MonthlyPayroll/GetUsersMonthlyPayslips", input);
    return response.data;
}

export async function GetPayrollPreflight(input: PayrollPreflightInput) {
    const response = await request.post<Result<PayrollPreflightView>>("MonthlyPayroll/GetPayrollPreflight", input);
    return response.data;
}

export async function MarkMonthlyPayslipsAsPaid(input: MonthlyPayrollInput) {
    const response = await request.post<Result<boolean>>("MonthlyPayroll/MarkMonthlyPayslipsAsPaid", input);
    return response.data;
}

export async function MarkMonthlyPayslipsAsUnpaid(input: MonthlyPayrollInput) {
    const response = await request.post<Result<boolean>>("MonthlyPayroll/MarkMonthlyPayslipsAsUnpaid", input);
    return response.data;
}

// CO-341: year/month name the payroll period the payslips are written for. They MUST be the same values
// the preflight ran against — the wizard's month picker used to reach GetPayrollPreflight only, and the
// write silently used the server's current month instead. Sent as query parameters so the body keeps its
// legacy `string[]` shape (see the controller comment).
export async function GenerateUsersMonthlyPayslips(userIds : string[], year : number, month : number){
    const response=await request.post<Result<boolean>>(`MonthlyPayroll/GenerateUsersMonthlyPayslips?year=${year}&month=${month}`,userIds);
    return response.data;
}

export async function DownloadUsersMonthlyPayslipsSIFFile(input : MonthlyPayrollInput) {
    const response: AxiosResponse<Blob> = await request.post(
        `MonthlyPayroll/DownloadUsersMonthlyPayslipsSIFFile`,
        input,
        {
            responseType: 'blob',
            headers: {
                'Content-Type': 'application/json'
            },
            validateStatus: () => true, // Don't throw on non-2xx so we can read error body
        }
    );

    // If the server returned an error, the blob is actually JSON — parse and throw with messages
    if (response.status !== 200) {
        const text = await (response.data as Blob).text();
        try {
            const json = JSON.parse(text);
            const messages = (json.errors || []).map((e: { description?: string; message?: string }) => e.description || e.message || '').filter(Boolean);
            throw new Error(messages.join('\n') || `SIF generation failed (${response.status})`);
        } catch (e) {
            if (e instanceof Error && e.message.includes('\n')) throw e; // re-throw parsed error
            throw new Error(text || `SIF generation failed (${response.status})`);
        }
    }

    // Try to read filename from Content-Disposition; browsers require CORS expose for this header
    const headers = response.headers as any;
    const cd: string | undefined = headers['content-disposition'] || headers['Content-Disposition'];
    let fileName_ = `MonthlyPayslips_${input.year}-${String(input.month).padStart(2,'0')}_${Date.now()}.sif`;
    if (cd && cd.includes('filename=')) {
        try {
            const after = cd.split('filename=')[1];
            const extracted = after.split(';')[0].trim().replace(/"/g, '');
            if (extracted) fileName_ = extracted;
        } catch { /* ignore and keep fallback */ }
    }

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName_);

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}